import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import StripeForm from '../StripeForm';

import N1 from './1';
import N2 from './2';
import N3 from './3';
import N4 from './4';
import N5 from './5';
import N6 from './6';
import N7 from './7';


const HomeProfilazione = () => {
    const { prof } = useParams()
    const [id, setId] = useState()
    const [wizard, setWizard] = useState(1)

    useEffect(() => {
        fetch(document.apiURL + '/book', {
            method: 'POST',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(
                {
                    "ip": "1.1.1.1"
                }
            )
        })
            .then(response => response.json())
            .then(response => {
                if (response.id !== null) {
                    setId(response.id)
                }
            });
    }, [prof])
    return (<> 
        {wizard === 1 && <N1 bookid={id} profid={prof} nextPage={() => setWizard(2)} previuosPage={() => window.location ="/ "} home={() => window.location ="/ "} />}
        {wizard === 2 && <N2 bookid={id} nextPage={() => setWizard(3)} previuosPage={() => setWizard(1)} home={() => window.location ="/ "}/>}
        {wizard === 3 && <N3 bookid={id} nextPage={() => setWizard(4)} previuosPage={() => setWizard(2)} home={() => window.location ="/ "}/>}
        {wizard === 4 && <N4 bookid={id} nextPage={() => setWizard(5)} previuosPage={() => setWizard(3)} home={() => window.location ="/ "}/>}
        {wizard === 5 && <N5 bookid={id} nextPage={() => setWizard(6)} previuosPage={() => setWizard(4)} home={() => window.location ="/ "}/>}
        {wizard === 6 && <N6 bookid={id} nextPage={() => setWizard(7)} previuosPage={() => setWizard(5)} home={() => window.location ="/ "}/>}
        {wizard === 7 && <StripeForm bookid={id} nextPage={() => setWizard(8)} />}
        {wizard === 8 && <N7 />}
    </>)
}

export default HomeProfilazione;